import React, { createContext, useContext, useEffect, useState } from 'react'
import { Theme } from '../types'

interface ThemeContextType {
 theme: Theme
 toggleTheme: () => void
 setTheme: (theme: Theme) => void
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

interface ThemeProviderProps {
 children: React.ReactNode
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
 const [theme, setThemeState] = useState<Theme>(() => {
 // Verifica se há tema salvo no localStorage
 const savedTheme = localStorage.getItem('theme') as Theme
 if (savedTheme) {
 return savedTheme
 }
 
 // Verifica preferência do sistema
 if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
 return 'dark'
 }
 
 return 'light'
 })

 useEffect(() => {
 // Aplica o tema ao documento
 const root = document.documentElement
 if (theme === 'dark') {
 root.classList.add('dark')
 } else {
 root.classList.remove('dark')
 }
 
 // Salva no localStorage
 localStorage.setItem('theme', theme)
 }, [theme])

 const toggleTheme = () => {
 setThemeState(prevTheme => prevTheme === 'light' ? 'dark' : 'light')
 }

 const setTheme = (newTheme: Theme) => {
 setThemeState(newTheme)
 }

 return (
 <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
 {children}
 </ThemeContext.Provider>
 )
}

export const useTheme = (): ThemeContextType => {
 const context = useContext(ThemeContext)
 if (context === undefined) {
 throw new Error('useTheme must be used within a ThemeProvider')
 }
 return context
}
